import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { User, Book, Bell } from "lucide-react";
import { API_BASE } from "../config";
import "../styles/homePage.css";
import apiFetch from "../apiFetch";
import UserSettingsModal from "./UserSettingsModal";

export default function PageHeader({ pageTitle, pageSubtitle, headerActions }) {
  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "Guest";
  const userId = localStorage.getItem("userId");
  const [level, setLevel] = useState(1);
  const [rank] = useState("Scholar");

  useEffect(() => {
    if (!userId) return;
    apiFetch(`/api/resources/xp/${userId}`)
      .then((r) => r.json())
      .then((d) => {
        if (typeof d.level === "number") setLevel(d.level);
      })
      .catch(() => {});
  }, [userId]);

  return (
    <header className="header page-header">
      <div className="header-left">
        <div
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/home")}
        >
          <Book size={28} color="#fff" />
        </div>
        <div>
          <h1 className="title">Owllet Reading Quest</h1>
          <p className="subtitle">Master comprehension through adventure</p>
        </div>
      </div>

      {pageTitle && (
        <div className="page-header-title">
          <h2 className="page-header-h2">{pageTitle}</h2>
          {pageSubtitle && <p className="page-header-sub">{pageSubtitle}</p>}
        </div>
      )}

      <div className="header-right">
        {headerActions && (
          <div className="page-header-actions">{headerActions}</div>
        )}
        <div className="profile">
          <User size={32} color="#6b21a8" />
          <div className="profile-info">
            <p className="profile-name">{username}</p>
            <p className="profile-rank">
              Level {level} {rank}
            </p>
          </div>
          <div className="notifications">
            <Bell size={24} />
          </div>
          <UserSettingsModal />
        </div>
      </div>
    </header>
  );
}
